<template>
  <div>
    <b-container>
      <div @drop="_drop" @dragenter="_suppress" @dragover="_suppress">
        <div class="row">
          <div class="col-sm-12">
            <b-form>
              <!-- <div class="form-group">
                                                <label for="file">Spreadsheet</label>
                                                <input type="file" class="form-control" id="file" :accept="SheetJSFT" @change="_change" />

                                            </div> -->
              <b-form-group
                id="exampleInputGroup2"
                label="Select File:"
                label-for="exampleInput2"
              >
                <input
                  id="exampleInput2"
                  type="file"
                  class="form-control"
                  :accept="SheetJSFT"
                  @change="_change"
                />
              </b-form-group>
            </b-form>
          </div>
        </div>
        <!-- <div class="row">
            <div class="col-sm-12">
                <button :disabled="data.length ? false : true" class="btn btn-success" @click="_export">Export</button>
            </div>
        </div> -->
        <div class="row">
          <div class="col-sm-12">
            <div>
              <span>{{ uploadlog }} </span>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import apis from "@/apis";
const _XLSX = require("xlsx");
const X = typeof XLSX !== "undefined" ? XLSX : _XLSX;
const make_cols = (refstr) =>
  Array(X.utils.decode_range(refstr).e.c + 1)
    .fill(0)
    .map((x, i) => ({ name: X.utils.encode_col(i), key: i }));
/* see Browser download file example in docs */
function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}
const _SheetJSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm",
]
  .map(function (x) {
    return "." + x;
  })
  .join(",");
export default {
  data() {
    return {
      uploadlog: "",

      SheetJSFT: _SheetJSFT,
      alertText: "",
    };
  },
  methods: {
    _suppress(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },
    _drop(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const files = evt.dataTransfer.files;
      if (files && files[0]) this._file(files[0]);
    },
    _change(evt) {
      const files = evt.target.files;
      if (files && files[0]) {
        //Confirm if the existing data to be deleted.

        this._file(files[0]);
      }
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = X.utils.aoa_to_sheet(this.data);
      const wb = X.utils.book_new();
      X.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate X file */
      const wbout = X.write(wb, { type: "binary", bookType: "xlsx" });
      /* send to client */
      saveAs(
        new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
        "sheetjs.xlsx"
      );
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = X.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        // const data = X.utils.sheet_to_json(ws, {header:1});
        const data = X.utils.sheet_to_json(ws);

        //Use Javascript Array prototype to format the input json to Firebase format.

        Array.prototype.sumUnic = function () {
          var returnArr = [];
          var obj = this;
          for (var x = 0; x < obj.length; x++) {
            (function (source) {
              if (returnArr.length == 0) {
                var doc = {};

                doc["Board"] =
                  source[
                    "Name of the 'Security Guards Board' You are Related with *"
                  ];
                doc["name"] = source["Full Name *"];
                doc["FatherName"] = source["Father Name *"];
                doc["Address"] = source["Address *"];
                doc["State"] = source["State *"];
                doc["City"] = source["City *"];
                doc["PinCode"] = source["Pin Code *"];
                doc["Designation"] = source["Designation *"];
                doc["BirthDate"] = source["Date of Birth *"];
                doc["Age"] = source["Age"];
                doc["Education"] = source["Education *"];
                doc["Gender"] = source["Gender *"];
                doc["MaritalStatus"] = source["Marital Status *"];
                doc["AgencyName"] = source["Agency Name *"];
                doc["JobDuration"] = source["Job Duration in the Agency *"];
                doc["PrincipalEmpName"] = source["Principal Employer Name *"];
                doc["PrincipalEmpJobDurth"] =
                  source["Job Duration with Principal Employer *"];
                doc["CurrSal"] = source["Current Salary *"];
                doc["SalDate"] = source["Salary Day *"];
                doc["SalMode"] = source["Salary Mode *"];
                doc["SalSlip"] = source["Is Salary Slip Provided to You? *"];
                doc["BankName"] =
                  source["Name of Bank where Salary is Credited *"];
                doc["BankBranch"] = source["Bank Branch Name *"];
                doc["AccNo"] = source["Bank Account Number *"];
                doc["WorkingHours"] = source["Daily Working Hours *"];
                doc["OTRate"] = source["Overtime Charges *"];
                doc["Weeklyoff"] = source["Weekly Off *"];
                doc["PaidLeave"] = source["Paid Leave *"];
                doc["PaidLeavesNum"] = source["Number of Paid Leaves *"];
                doc["PaidHolidays"] = source["Paid Holidays *"];
                doc["PaidHolidayNum"] = source["Number of Paid Holidays *"];
                doc["AccidentInsurance"] =
                  source["Do you get compensation for accident *"];
                doc["LTA"] = source["Travel Allowance *"];
                doc["LTAAmount"] = source["Travel Allow. Amount *"];
                doc["HRA"] = source["HRA *"];
                doc["HRAAmount"] = source["HRA Amount *"];
                doc["Bonus"] = source["Bonus Amount *"];
                doc["BonusDistribution"] = source["When Do You Get Bonus*"];
                doc["PF"] = source["Is Provident Fund Deducted From Salary? *"];
                doc["PFNo"] = source["PF No *"];
                doc["ESIC"] = source["Is ESIC Deducted from Salary *"];
                doc["ESICNo"] = source["ESIC No *"];
                doc["MedicalBenifits"] =
                  source["Do You Get Medical Benifits? *"];
                doc["AccidentInsu"] =
                  source["Are you Covered under Accident Insurance? *"];
                doc["Amt"] = source["Accident Insurance Amount? *"];
                doc["Permanant"] = source["Are You Permanent? *"];
                doc["AppLetter"] =
                  source["Have You Received Appointment Letter? *"];
                doc["Uniform"] = source["Is Uniform Provided By Agency? *"];
                doc["PayForUniform"] = source["Do You Pay For Uniform? *"];
                doc["SrvcYrsUniform"] =
                  source["No Of Years Of Service To Receive Uniform? *"];
                doc["IsGunHolder"] = source["Do You Hold Gun? *"];
                doc["IsGunLicense"] = source["Do You Have Licence For Gun? *"];
                doc["GunLicenseNo"] = source["License Number of Gun *"];
                doc["Traning"] = source["Have You Received Training? *"];
                doc["TraningLocation"] = source["Traning Location *"];
                doc["UnionName"] = source["Union Name *"];

                //returnArr.push(doc);
                console.log(doc);
                let payload = {
                  RegistrationID: "00000000-0000-0000-0000-000000000000",
                  UserLoginID: "00000000-0000-0000-0000-000000000000",
                  FormDetails: JSON.stringify(doc),
                  iscomplete: true,
                  LastCompletePage: 0,
                  RegistrationType: 12,
                  BoardID:
                    source[
                      "Name of the 'Security Guards Board' You are Related with *"
                    ],
                  RegisteringAgency: "F91C0487-73C4-4C37-AB0F-EDA4DC1B4235", //userinfo.UserId,
                  EntityName: source["Full Name *"],
                };

                let promise = apis.SaveRegistrationDetails(payload);
                promise
                  .then((response) => {
                    if (
                      response.status == 200 &&
                      response.body != "Error in Registration"
                    ) {
                      //this.alertText += "Record Saved Successfully";
                      returnArr.push["Record Saved Successfully"];
                    }
                  })
                  .catch((err) => {
                    //this.alertText += err.body;
                    returnArr.push["ERROR:" + err.body];
                  });
              }
            })(obj[x]);
          }

          return returnArr;
        };

        let n = data.sumUnic().length;
        this.uploadlog = "Uploaded Records : " + n;
      };
      reader.readAsBinaryString(file);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/OtherRegistrations/ExcelUpload.vue